import './Pagination.css';

interface Props {
  page: number;
  pageSize: number;
  total?: number;
  hasMore?: boolean;
  onPage: (page: number) => void;
}
export function Pagination({ page, pageSize, total, hasMore, onPage }: Props) {
  const start = total === 0 ? 0 : page * pageSize + 1;
  const end = total !== undefined ? Math.min(total, (page + 1) * pageSize) : (page + 1) * pageSize;
  const canPrev = page > 0;
  const canNext = hasMore !== undefined ? hasMore : (total !== undefined ? (page + 1) * pageSize < total : true);
  return (
    <div className="nb-pager">
      <div className="nb-pager__range">
        {total !== undefined
          ? <>Showing <strong>{start.toLocaleString()}</strong> – <strong>{end.toLocaleString()}</strong> of <strong>{total.toLocaleString()}</strong></>
          : <>Page <strong>{page + 1}</strong></>}
      </div>
      <div className="nb-pager__btns">
        <button disabled={!canPrev} onClick={() => onPage(page - 1)}>← Prev</button>
        <button disabled={!canNext} onClick={() => onPage(page + 1)}>Next →</button>
      </div>
    </div>
  );
}
